import useAuth from "@/hooks/useAuth";
import React, { useEffect } from "react";
import { Navigate, Route, Routes, useNavigate } from "react-router-dom";

const LogoutPage = () => {
  const { logout, isTabletUser } = useAuth();
  const navigate = useNavigate();
  useEffect(() => {
    logout();
    if(!isTabletUser)
      navigate("/auth/login");
    else
      navigate("/auth-tablet/login");
  }, []);

  return null;
};

export default LogoutPage;
